$(document).ready(function () {
    let visibleSlides = 3;
    if (document.querySelector(".plenny-section--hp-62")) visibleSlides = 4;

    $('.plenny-slider').slick({
        slidesToShow: visibleSlides,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow:
            '<button class="slider-arrow slider-prev"><img src="https://cdn.shopify.com/s/files/1/0004/9630/4187/files/arrow-left-cro.svg?v=1781861174"></button>',

        nextArrow:
            '<button class="slider-arrow slider-next"><img src="https://cdn.shopify.com/s/files/1/0004/9630/4187/files/arrow-right-cro.svg?v=1781861185"></button>',

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.27
                }
            }
        ]
    });

    $(document).on('click', '.tab-btn', function () {

        var target = $(this).data('tab');

        $('.tab-btn').removeClass('active');
        $(this).addClass('active');

        $('.tab-panel').removeClass('active');
        $('#' + target).addClass('active');

        $('.plenny-slider').slick('setPosition');

    });
});

document.addEventListener('DOMContentLoaded', () => {
    let howWorkTabWrap = document.querySelectorAll('.js-how-work-tab-wrap');

    howWorkTabWrap.forEach((wrapper) => {
        
        let tabs = wrapper.querySelectorAll('.js-how-work-tab-block');

        let activateTab = (tab) => {
            const targetId = tab.dataset.tab;

            wrapper.querySelector('.js-how-work-tab-block.is-active-tab')?.classList.remove('is-active-tab');

            wrapper.querySelector('.js-how-work-media.is-active-media-block')?.classList.remove('is-active-media-block');

            tab.classList.add('is-active-tab');

            wrapper.querySelector(`.js-how-work-media[id="${targetId}"]`)?.classList.add('is-active-media-block');
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => activateTab(tab));
        });
    });
    
    window.addEventListener('load', () => {
        howWorkTabWrap.forEach((wrapper) => {
            wrapper.querySelector('.js-how-work-tab-block')?.click();
        });
    });
});